import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Input } from 'antd';

export default function SocialMediaLinks({ cellValue, onFocusOut }) {
  const [value, setValue] = useState(cellValue);
  const onChangeInput = (name) => (e) => {
    e.persist();
    setValue((prev) => ({ ...prev, [name]: e.target?.value }));
  };

  return (
    <div>
      <label>
        Facebook URL:
        <Input
          placeholder="type here"
          name="facebookUrl"
          type="text"
          onChange={onChangeInput('facebookUrl')}
          onBlur={onFocusOut}
          value={value.facebookUrl}
        />
      </label>
      <br />
      <label>
        Twitter URL:
        <Input
          placeholder="type here"
          name="twitterUrl"
          type="text"
          onChange={onChangeInput('twitterUrl')}
          onBlur={onFocusOut}
          value={value.twitterUrl}
        />
      </label>
      <br />
      <label>
        Instagram URL:
        <Input
          placeholder="type here"
          name="instagramUrl"
          type="text"
          onChange={onChangeInput('instagramUrl')}
          onBlur={onFocusOut}
          value={value.instagramUrl}
        />
      </label>
    </div>
  );
}

SocialMediaLinks.propTypes = {
  cellValue: PropTypes.object,
  onFocusOut: PropTypes.func,
};

SocialMediaLinks.defaultProps = {
  cellValue: {},
  onFocusOut: () => {},
};
